export class PlArrayUtils {
  static normalizeToArray<T>(value: T | T[]): T[] {
    return Array.isArray(value) ? value : [value];
  }
}
